import {WithDataError} from "types/api";
import {normalizedFetchApi} from "./util";
import {GoogleTagManager, UUID} from "@pinch-financial/pinch-ui-components";
import queryString from "query-string";

const baseUrl = `${window._env_.REACT_APP_PINCH_SERVICE_API_HOST}/google-tag-managers`;

export async function fetchGoogleTagManagerByOwnerIdsApi(
  ownerIds: UUID[]
): Promise<WithDataError<GoogleTagManager[]>> {
  const query: string = queryString.stringify({ownerIds}, {skipNull: true});
  return normalizedFetchApi(() => fetch(`${baseUrl}/all-by-owner-ids?${query}`));
}
